import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SubscribeSection() {
  return (
    <section className="relative overflow-hidden border-t border-background-800 bg-background-900">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-500/10 blur-3xl animate-glow-pulse" />
      <div className="relative mx-auto grid w-full max-w-content grid-cols-1 items-center gap-8 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-2">
        <div>
          <p className="text-xs tracking-[0.3em] text-primary-400">SUBSCRIBE</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">每周一封档案速递</h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-400">
            我们把当周更新的未解之谜与灵异杂谈整理成一封短信，附上本期最值得深读的那篇。无广告，随时可退订。
          </p>
          <ul className="mt-5 space-y-2 text-sm text-foreground-400">
            <li className="flex items-center gap-2">
              <i className="ri-check-line text-secondary-300" /> 每周三发送，不超过一封信
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-check-line text-secondary-300" /> 仅记录邮箱，不做任何其他用途
            </li>
          </ul>
        </div>
        <div className="rounded-lg border border-background-800 bg-background-950 p-5 md:p-7">
          <h3 className="font-heading text-lg font-semibold text-foreground-50">订阅更新</h3>
          <p className="mt-2 text-sm text-foreground-400">留下邮箱，下周三收到第一期。</p>
          <div className="mt-5">
            <SubscribeForm />
          </div>
        </div>
      </div>
    </section>
  );
}